// @ts-nocheck
import React from 'react';

const Kbd = ({ children, className = '' }) => (
  <kbd
    className={['mov-mono inline-block', className].join(' ')}
    style={{
      fontSize: 10.5,
      background: 'var(--mov-paper)',
      color: 'var(--mov-ink-soft)',
      border: '1px solid var(--mov-line-strong)',
      borderBottomWidth: 2,
      borderRadius: 5,
      padding: '1px 6px',
    }}
  >
    {children}
  </kbd>
);

export default Kbd;
